// Звернення до API XQShop з Bearer-токеном сесії Mini App (POST /tg/auth → token).
// Типово — той самий origin (dev-сервер/тунель проксіює /api/tg/* на API); у збірці для сервера — VITE_API_URL.
const BASE = ((import.meta.env.VITE_API_URL as string | undefined) ?? '/api').replace(/\/$/, '');
let token: string | null = null;

export class ApiError extends Error {
  constructor(public status: number, public code: string, public detail: unknown) {
    super(typeof detail === 'string' ? detail : code);
  }
}

export function setToken(t: string | null): void {
  token = t;
}

export async function api<T>(path: string, init: { method?: string; body?: unknown } = {}): Promise<T> {
  const res = await fetch(BASE + path, {
    method: init.method ?? (init.body ? 'POST' : 'GET'),
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: init.body ? JSON.stringify(init.body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new ApiError(res.status, data?.error ?? data?.code ?? 'error', data?.detail ?? data?.message);
  return data as T;
}

export type Persona = 'dispatcher' | 'partner' | 'driver' | 'family';
export type Auth = { token: string; persona: Persona; locale: string; name: string | null; start_param?: string | null };

export async function login(initData: string): Promise<Auth> {
  const a = await api<Auth>('/tg/auth', { body: { init_data: initData } });
  setToken(a.token);
  return a;
}
